export default __webpack_public_path__ + "static/media/smsc.3262fc7c.png";